import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Plus } from "lucide-react";

import { Button } from "@monorepo-apps/ui/src/components/button";
import { useTimelinePage } from "@/routes/_app/-use-timeline-page";
import { ImplementationGantt } from "@/presentation/components/timeline/implementation-gantt";
import { AddWorkstreamDialog } from "@/presentation/components/timeline/add-workstream-dialog";
import { PageHeader } from "@/presentation/components/shell/page-header";
import { useWorkspace } from "@/presentation/providers/workspace.provider";

export const Route = createFileRoute("/_app/timeline")({
  component: TimelinePage,
});

function TimelinePage() {
  const { model, isLoading, isError } = useTimelinePage();
  const { canWrite } = useWorkspace();
  const [adding, setAdding] = useState(false);

  return (
    <div className="animate-page-enter mx-auto flex w-full max-w-7xl flex-col">
      <PageHeader
        eyebrow="Live implementation plan"
        title="Timeline"
        summary="Workstreams on the milestone calendar — each bar filled to its board completion. The dashed line is today."
        actions={
          canWrite ? (
            <Button size="sm" variant="outline" onClick={() => setAdding(true)}>
              <Plus className="size-3.5" />
              Add workstream
            </Button>
          ) : null
        }
      />
      <div className="px-6 pt-6 pb-8 lg:px-10">
        {isError ? (
          <p className="text-muted-foreground text-xs italic">
            Could not load the board — try again shortly.
          </p>
        ) : isLoading || !model ? (
          <p className="text-muted-foreground text-xs italic">Loading the workplan…</p>
        ) : (
          <ImplementationGantt model={model} />
        )}
      </div>
      {canWrite ? <AddWorkstreamDialog open={adding} onClose={() => setAdding(false)} /> : null}
    </div>
  );
}
